module.exports = __webpack_public_path__ + "img/3right-n-e45d8544.png";